import { getClientWidth } from '@mc/mc-base-env/src/web/rem.js'
import { getPlatform } from '@/defines/environment/getters/get_platform'

const WIDTH = getClientWidth()

let rem = +((WIDTH * 2) / 15).toFixed(2)
rem = getPlatform() === 'pc' ? Math.min(55.2, rem) : rem
const widthFixed = WIDTH > 768 ? 668 : WIDTH
// 1rem换算px
export const _rem = rem
// 浏览器宽
export const _width = widthFixed
